import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

// based on https://icons.app.sbb.ch/kom/chevron-small-down-small.svg
export const ChevronSmallDown: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <polyline fill="none" stroke={iconColor} points="8.092 10.35 11.996 14.3 15.9 10.352" />
    </svg>
  );
};
